import React from 'react';

import AppsIcon from '@atlaskit/icon/core/apps';
import { B400, N500 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

import { type NounKeys, nouns } from '../../../common/constants/nouns';
import { type IconProps, type ProductKeys, products } from '../../../common/constants/products';

export type ProductIconProps = Omit<IconProps, 'appearance'> & {
	isSelected?: boolean;
	product: ProductKeys | undefined;
};

export type ProductOrNounIconProps = Omit<IconProps, 'appearance'> & {
	isSelected?: boolean;
	productOrNounKey: ProductKeys | NounKeys | undefined;
};

export const ProductIcon = ({
	product,
	size = 'medium',
	isSelected = false,
	...props
}: ProductIconProps) => {
	let Icon;
	if (product) {
		Icon = products[product].Icon;
		return <Icon {...props} size={size} appearance="brand" />;
	} else {
		return (
			<AppsIcon
				label=""
				spacing="spacious"
				color={isSelected ? token('color.icon.selected', B400) : token('color.icon', N500)}
			/>
		);
	}
};

export const ProductOrNounIcon = ({
	productOrNounKey,
	size = 'medium',
	isSelected = false,
	...props
}: ProductOrNounIconProps) => {
	let Icon;
	if (productOrNounKey) {
		Icon = products[productOrNounKey]?.Icon || nouns[productOrNounKey]?.Icon;
		return <Icon {...props} size={size} appearance="brand" />;
	} else {
		return (
			<AppsIcon
				label=""
				spacing="spacious"
				color={isSelected ? token('color.icon.selected', B400) : token('color.icon', N500)}
			/>
		);
	}
};
